export default __webpack_public_path__ + "static/accents-text-accent-tokens-light-fa8521efd3bc841e382be651239fdd9b9393875e45f89b6bfcd30cea73db8bf0.png";